/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Link, Typography } from '@material-ui/core';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import axios from 'axios';
import Picker from '../UI/Picker/Picker';

// Styles
const useStyles = makeStyles((theme) => ({
  newsTitle: {
    color: theme.palette.interactive.main,
    fontSize: 40,
    paddingBottom: 10,
    [theme.breakpoints.between('0', '600')]: {
      fontSize: 28,
    },
  },
  backgroundBox: {
    width: '100%',
    height: '450px',
    padding: theme.spacing(6),
    backgroundColor: theme.palette.alternative.main,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
      height: 'auto',
    },
  },
  image: {
    position: 'relative',
    height: '450px',
    width: '100%',
    zIndex: 101,
    [theme.breakpoints.down('md')]: {
      height: '250px',
    },
  },
  tag: {
    backgroundColor: theme.palette.interactive.main,
    borderRadius: '3px',
    paddingLeft: '5px',
    paddingRight: '5px',
    marginLeft: '20px',
  },
  caption: {
    fontSize: 16,
    marginRight: 20,
    [theme.breakpoints.between('0', '600')]: {
      fontSize: 12,
    },
  },
  pressReleaseText: {
    fontWeight: 'Bold',
    color: 'black',
    fontSize: 16,
    [theme.breakpoints.between('0', '600')]: {
      fontSize: 12,
      fontWeight: 0,
    },
  },
  articleTitle: {
    color: theme.palette.primary.main,
  },
  pagination: {
    paddingTop: 40,
    margin: '0 auto',
  },
  datePicker: {
    paddingBottom: 10,
    float: 'right',
    [theme.breakpoints.down('md')]: {
      float: 'left',
    },
  },
  noNews: {
    textAlign: 'center',
  },
  imageTag: {
    width: '100%',
    height: '100%',
    layout: 'fill',
    objectFit: 'cover',
  },
}));

const apiGetFilteredNews = async (setAllNewsPosts, fromDate, toDate) => {
  await axios.get(`https://homepage-cms.wgh.objective.se/News-Articles?publishedDate_gte=${fromDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')}&publishedDate_lte=${toDate.endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')}&_sort=publishedDate:DESC&_start=0`)
    .then((response) => setAllNewsPosts(response.data))
    .catch((error) => {
      console.log(error.message);
    });
};

const News = (props) => {
  const classes = useStyles();
  const { data } = props;
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());

  const [allNewsPosts, setAllNewsPosts] = useState(data.newsArticles);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(4);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = allNewsPosts.slice(indexOfFirstPost, indexOfLastPost);

  const isEven = (value) => {
    if (value % 2 === 0) return true;
    return false;
  };

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };

  const getFilteredNews = () => {
    apiGetFilteredNews(setAllNewsPosts, startDate, endDate);
    setCurrentPage(1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  return (
    <Box pt={14} position="relative">
      <Grid container display="flex">
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item md={4} xs={12}>
              <Typography variant="h2" className={classes.newsTitle}>NEWS FEED</Typography>
            </Grid>
            <Grid item md={3} xs={6}>
              <Picker
                label="Start date"
                value={startDate}
                action={(date) => setStartDate(moment(date))}
                variant="outlined"
                fieldType="formField"
                fullWidth
              />
            </Grid>
            <Grid item md={3} xs={6}>
              <Picker
                label="End date"
                value={endDate}
                action={(date) => setEndDate(moment(date))}
                variant="outlined"
                fieldType="formField"
                fullWidth
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <Button
                variant="contained"
                size="large"
                onClick={() => getFilteredNews()}
                color="primary"
                fullWidth
              >
                GET NEWS
              </Button>
            </Grid>
          </Grid>
          <Box mt={4} />
          {currentPosts && currentPosts.length > 0 ? (
            <Box>
              {currentPosts.map((item, i) => (
                <Box mt={4} key={item.id}>
                  <Grid container xs={12} item>
                    <Grid
                      item
                      xs={12}
                      lg={6}
                      className={classes.backgroundBox}
                      order={{ xs: 2, lg: isEven(i) ? 1 : 2 }}
                    >
                      <Typography variant="h5" className={classes.articleTitle}>{item.title}</Typography>
                      <Box mt={1} />
                      <Box flexDirection="row" display="flex">
                        <Typography variant="caption" className={classes.caption}>{moment(item.publishedDate).format('YYYY-MM-DD - HH:mm')}</Typography>
                        <Typography className={classes.pressReleaseText} variant="caption" color="secondary">{item.tag}</Typography>
                      </Box>
                      <Box mt={1} />
                      <Typography variant="body1">{item.preamble}</Typography>
                      <Box mt={2} />
                      <Link href={`/news/${item.id}`}>
                        <Button variant="contained" className={classes.button} size="large" color="primary">
                          Read more
                        </Button>
                      </Link>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      lg={6}
                      order={{ xs: 1, lg: isEven(i) ? 2 : 1 }}
                    >
                      <Box className={classes.image}>
                        <img
                          src={item ? item.picture.url : '/'}
                          className={classes.imageTag}
                          alt="News"
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              ))}
            </Box>
          ) : (<Typography variant="body1" className={classes.noNews}>No News between selected dates</Typography>) }
        </Grid>
        <Box className={classes.pagination}>
          <Pagination
            count={Math.ceil(allNewsPosts.length / 4)}
            page={currentPage}
            onChange={handleChange}
          />
        </Box>
      </Grid>
    </Box>
  );
};

export default News;
